/* eslint-disable quotes */
export default {
  dashboard: {
    title: "TABLEAU DE BORD GEOSPATIAL DE LA SURVEILLANCE DE LA SANTE ANIMALE",
    zones: "Zones",
    registration: "Enregistrements",
    localisedRegistration: "Enregistrements géolocalisées",
    refresh: "Rafraîchir",
    streetView: "Vue de rue",
    satelliteView: "Vue satellite",
    rechercherRegistrationRef: "Rechercher une registration avec sa référence",
    barChartTitle: "Nombre d’espèces affectés par type de maladie",
    lineChartTitle: "Évolution des principales maladies animales",
    mapTitle: 'Localisation géographique des foyers épidémiques signalés',
    pieChartTitle: "Répartition des animaux malades par espèce",
    boxCardTitle: "Répartition des animaux malades par race",
    copyRight: "© 2025 Kella DOUZOUNE. Tous droits réservés.",
    sickAnimals: "Animaux malades",
    selectSpecie: "Sélectionnez une espèce",
    selectYear: "Sélectionnez une année",
    years: 'Années',
    months: {
      1: 'Jan',
      2: 'Fév',
      3: 'Mar',
      4: 'Avr',
      5: 'Mai',
      6: 'Jun',
      7: 'Jul',
      8: 'Aoû',
      9: 'Sep',
      10: 'Oct',
      11: 'Nov',
      12: 'Déc',
    },
  },
  general: {
    close: "Fermer",
    description: "Description",
    code: "Code",
    nom: "Nom",
    libelle: "Libelle",
    title: "Titre",
    type: "Type",
    search: "Chercher",
    add: "Ajouter",
    export: "Exporter",
    id: "ID",
    date: "Date",
    author: "Auteur",
    status: "Statut",
    actions: "Actions",
    edit: "Modifier",
    delete: "Supprimer",
    cancel: "Annuler",
    confirm: "Confirmer",
    keyword: "Mots clés",
    role: "Role",
    permissions: "Permissions",
    menus: "Menus",
    rolesEtpermissions: "Rôles et permissions",
    deleteWarningText: "Êtes-vous sûr de vouloir supprimer ?",
    deleteConfirmButtonText: "Oui supprimer",
    deleteCancelButtonText: "Non laisser",
    save: "Sauvegarder",
    saving: "Sauvegarde ...",
    closingWarningText: "Êtes-vous sûr de vouloir fermer ?",
    notFound: "Aucun élément trouvé",
    actives: "Actives",
    visible: "Visible",
    disponibles: "Disponibles",
    M_actives: "Activés",
    F_actives: "Activées",
    M_desactives: "Désactivés",
    F_desactives: "Désactivées",
    M_supprimes: "Supprimés",
    F_supprimes: "Supprimées",
    corbeille: "Corbeille",
    restaurer: "Restaurer",
    suppressionDefinitive: "Suppression définitive",
    nonActives: "Non Actives",
    nonVisibles: "Non Visibles",
    F_actif: "Active",
    M_actif: "Actif",
    deleteContinue: "Continuer ?",
    suppressionAnnule: "Suppression annulée",
    filter: "Filtrer",
    init: "Réinitialiser",
    statusUpdated: "Mise à jour du status éffectuée avec succès !",
    statusUpdateError:
      "Désolé, une erreur s'est produite lors de la mise à jour du status",
    ouiSupprimer: "Oui supprimer",
    irrversibleMessage: "Cette action est irréversible",
    SureQuestion: "Etes-vous sûre ?",
    periode: "Période",
    startDateplaceholder: "Date de début",
    endDateplaceholder: "Date de fin",
    DaterangeSeparator: "à",
    ImapeUploadFieldText: "Cliquer pour envoyer",
    clotures: "Clôturés",
    labelColonneCloturer: "clôturée",
    allpermissions: "Toutes les permissions",
    formInvalid:
      "Votre formulaire n'est pas valide ! Veuillez vérifier les données !",
    admins: "Admins",
    donors: "Donors",
    recipients: "Recipients",
    others: "Autres",
    processing: "Processing",
    success: "Success",
    error: "Error",
    disabled: "Disabled",
    enabled: "Enabled",
    details: "Détails",
    yes: "Yes",
    no: "No",
    paredExchange: "Paired exchange",
    guest: "Invités",
    editors: "Editeurs",
    othersUsers: "Autres utilisateurs",
    users: "Utilisateurs",
    publish: "Publier",
    SaveDraft: "Enregistrer comme brouillon",
    envoiEncours: "Envoi en cours...",
    envoyer: "Envoyer",
    sendGeneralNotification: "Notifier tous",
    invalidForm: "Veuillez revérifier les informations saisies",
    accountIsActive: "Votre compte est actif !",
    accountIsActiveDetails:
      "Votre compte est bien actif, merci de télécharger l'application GéoSanté disponible sur AppStore et PlayStore pour accéder à votre compte",
    reference: "Référence",
    unknown: "Inconnu",
    noData: "Aucune donnée",
    import: "Importer",
  },
  route: {
    dashboard: "Accueil",
    introduction: "Introduction",
    documentation: "Documentation",
    guide: "Guide",
    permission: "Permission",
    pagePermission: "Page de Permission",
    rolePermission: "Role et Permission",
    icons: "Icones",
    components: "Composants",
    componentIndex: "Introduction",
    errorPages: "Pages d'erreur",
    page401: "401",
    page404: "404",
    errorLog: "Log",
    administration: "Administration",
    users: "Utilisateurs",
    userProfile: "Profile Utilisateur",
    regions: "Les régions",
    parcelles: "Les parcelles",
    campagneagricoles: "Campagnes agricoles",
    species: "Les Espèces",
    diseases: "Les Maladies",
    provinces: "Les Provinces",
    departments: "Les Départements",
    municipalities: "Les Communes",
    villages: "Les Villages",
    breeds: "Les Races",
    localites: "Les localités",
    registrations: "Les Enregistrements",
    reports: "Reports",
    subscriptions: "Membres",
    articles: "Articles",
    tags: "Tags",
    categoriestags: "Catégories et tags",
    editArticle: "Modifier l'article",
    discussions: "Discussions",
    UserProfile: "Profile",
    comments: "Commentaires",
    locations: "Localités",
    animals: "Animaux",
  },
  navbar: {
    logOut: "Déconnexion",
    dashboard: "Accueil",
    github: "Github",
    theme: "Theme",
    size: "Taille globale",
    profile: "Profile",
  },
  login: {
    title: "Se connecter",
    logIn: "Connecté",
    username: "Identifiant",
    password: "Mot de passe",
    email: "Adresse email",
    correctEmail: "Entrez une adresse email correcte",
    shortPassword: "Le mot de passe est trop court (minimum 6 lettres)",
    emailOrUsername: "Identifiant",
    emailOrUsernameRequired:
      "Veuillez saisir votre nom d'utilisateur ou e-mail",
  },
  passwordreset: {
    enterCode: "Entrez le code envoyé par mail",
    checkCode: "Vérifier",
    token: "Code",
    forgotPassword: "Mot de passe oublié",
    resendcode: "Renvoyer le code",
    enterEmail: "Entrez votre adresse e-mail",
    sendcode: "Envoyer le code",
    setYourPassword: "Définissez votre nouveau mot de passe",
    confirmPassword: "Confirmez votre mot de passe",
    password: "Entrez votre mot de passe",
    savepassword: "Enregistrer",
    ConfirmPasswordRequired: "Confirmez votre mot de passe",
    codeIsRequired: "Veuillez saisir le code",
    successEnd: "Votre mot de passe a été changé !",
    successEndDetails:
      "Vous avez changé votre mot de passe avec succès ! vous pouvez maintenant vous connecter avec votre nouveau mot de passe",
    codeIsValid: "Code valide ! veuillez entrer votre nouveau mot de passe",
    codeSent: "Un code vous a été envoyé par mail, merci de vérifier",
  },
  permission: {
    addRole: "Nouveau Role",
    editPermission: "Modifier la Permission",
    editPermissions: "Modifier les Permissions",
    roles: "Roles",
    switchRoles: "Activer les roles",
    delete: "Supprimer",
    confirm: "Confirmer",
    cancel: "Annuler",
    permissionsUpdated: "Les permissions ont bien été mises à jour !",
    extraPermissions: "Permissions supplémentaires",
    addedPermissions: "Permissions ajoutées",
    noSelectionAdd: "Aucune permission ajoutée",
    manage: "Gérer les permissions",
    addPermissions: "Ajouter des permissions",
    tableName: "Nom de la table",
    NameRequired: "Veuillez saisir le nom",
    iscreatedSuccessfully: "Permission ajoutée avec succès",
    name: "Permission",
    suppressionEffectue: "Permission supprimée avec succès",
  },
  excel: {
    export: "Exporter",
    selectedExport: "Exporter les éléments sélectionnés",
    placeholder:
      "Entrez le nom du fichier s'il vous plaît (par défaut : liste-excel)",
  },
  theme: {
    change: "Changer le Theme",
    documentation: "documentation du Theme",
    tips: "Conseils: Il est différent du choix de thème sur la barre de navigation, ce sont deux méthodes de skinning différentes, chacune avec des scénarios d'application différents.",
  },
  settings: {
    title: "Configuration du style de Page",
    theme: "Couleur du Theme",
    tagsView: "Afficher les tags",
    fixedHeader: "Fixer la d'entête",
    sidebarLogo: "Logo",
  },
  tagsView: {
    refresh: "Rafraîchir",
    close: "Fermer",
    closeOthers: "Fermer les autres",
    closeAll: "Fermer tout",
  },
  user: {
    name: "Name",
    user: "Utilisateur",
    role: "Role",
    password: "Mot de passe",
    c_password: "Confirmer",
    nom: "Nom",
    prenom: "Prenom",
    email: "Adresse Email",
    username: "Identifiant",
    code: "Code",
    EditPermissions: "Modifier les permissions",
    AddUser: "Ajouter un utilisateur",
    selectRole: "Sélectionnez un rôle",
    PasswordsInconform: "Les mots de passes ne sont pas conformes",
    RoleRequired: "Veuillez sélectionner un rôle",
    NomRequired: "Veuillez saisir le nom",
    EmailRequired: "Veuillez saisir le mail",
    EmailInvalide: "Veuillez saisir une adresse email valide",
    PasswordRequired: "Veuillez entrer le mot de passe",
    deleteWarn: "Ceci supprimera l'utilisateur",
    deleteContinue: "Continuer ?",
    cancel: "Annuler",
    suppressionEffectue: "Suppression effectuée avec succès!",
    suppressionAnnule: "Suppression annulée",
    NewUser: "Nouveau utilisateur",
    iscreatedSuccessfully: "a été crée avec succès",
    PermissionsUpdated: "Permissions mise à jour avec succès!",
    users: "Utilisateurs",
    edit: "Modifier l'utilisateur",
    PasswordMin6: "Doit avoir au moins 6 caractères",
    isupdatedSuccessfully:
      "Mise à jour de l'utilisateur éffectuée avec succès !",
    changeCredentils: "Modifier le mot de passe",
    nochangeCredentils: "Ne pas modifier le mot de passe",
    changeAvatar: "Changer l'avatar",
    account: "Compte",
    enterPassword: "Entrez votre mots de passe pour continuer",
    profileUpdated: "Votre profile a bien été mise à jour !",
    willAddPassword: "L'utilisateur ajoutera son mot de passe",
    willAddPasswordMessage:
      "Un mail sera envoyé à l'utilisateur sur l'adresse email reinseigné avec un lien pour intégrer son mot de passe",
  },
  message: {
    message: "Message",
    messages: "Messages",
    subject: "Sujet",
    description: "Description",
    subjectRequired: "Entrez le sujet",
    messageRequired: "Entrez le message",
    deleteWarn: "Le message sera supprimé",
    suppressionEffectue: "Message supprimé avec succès",
    NewCategorie: "Nouveau message",
    iscreatedSuccessfully: "crée avec succès",
    sentMessage: "Votre message a bien été envoyé",
    isupdatedSuccessfully: "Message mis à jour avec succès",
    created_at: "Crée le",
    edit: "Modifier le message",
    AddCategorie: "Nouveau message",
    sendTo: "Envoyer à ",
  },
  roles: {
    deleteWarn: "Attention, ceci supprimera le role",
    permissions: "Permissions",
    nom: "Nom du rôle",
    users: "Utilisateurs",
    extraMenus: "Menus supplémentaires",
    InheritedfromRole: "Hérité du rôle",
    addRole: "Ajouter un rôle",
    name: "Role",
    NewRole: "Nouveau rôle",
    iscreatedSuccessfully: "crée avec succès!",
    isupdatedSuccessfully: "Le rôle a été mis à jour avec succès",
    NameRequired: "Veillez saisir le rôle",
    edit: "Modifier le rôle",
    suppressionEffectue: "Rôle supprimé avec succès",
    description: {
      admin: "Le Super Administrateur administre l'application",
      manager: "Le Manager est le gérant de l'application",
      editeur: "Utilisateur pouvant intégrer des données",
      utilisateur: "Utilisateur normal",
      visiteur: "les visiteurs ont juste un droit de visualisation",
    },
  },
  specie: {
    specie: "Espèce",
    species: "Les espèces",
    name: "Nom",
    body: "Description",
    NameRequired: "Veuillez saisir le nom de l'espèce",
    deleteWarn: "Ceci supprimera l'espèce",
    suppressionEffectue: "Espèce supprimée avec succès",
    NewSpecie: "Nouvelle Espèce",
    iscreatedSuccessfully: "crée avec succès",
    isupdatedSuccessfully: "Mise à jour de l'espèce éffectuée avec succès !",
    created_at: "Créee le",
    edit: "Modifier l'espèce",
    AddSpecie: "Nouvelle Espèce",
    selectSpecieTitle: "Sélectionnez l'espèce",
    specieRequired: "Veuillez sélectionner une espèce",
  },
  province: {
    province: "Province",
    provinces: "Les provinces",
    reference: "Référence",
    code: "Code",
    name: "Nom",
    NameRequired: "Veuillez saisir le nom de la province",
    deleteWarn: "Ceci supprimera la province",
    suppressionEffectue: "Province supprimée avec succès",
    NewProvince: "Nouvelle Province",
    iscreatedSuccessfully: "crée avec succès",
    isupdatedSuccessfully: "Mise à jour de la province éffectuée avec succès !",
    created_at: "Créee le",
    edit: "Modifier la province",
    AddProvince: "Nouvelle Province",
    selectProvinceTitle: "Sélectionnez la province",
    provinceRequired: "Veuillez sélectionner une province",
  },
  department: {
    department: "Département",
    departments: "Les départements",
    name: "Nom",
    NameRequired: "Veuillez saisir le nom du département",
    deleteWarn: "Ceci supprimera le département",
    suppressionEffectue: "Département supprimé avec succès",
    NewDepartment: "Nouveau département",
    iscreatedSuccessfully: "crée avec succès",
    isupdatedSuccessfully: "Mise à jour du département éffectuée avec succès !",
    created_at: "Crée le",
    edit: "Modifier le département",
    AddDepartment: "Nouveau Département",
    selectDepartmentTitle: "Sélectionnez le département",
    departmentRequired: "Veuillez sélectionner une département",
  },
  municipality: {
    municipality: "Commune",
    municipalities: "Les communes",
    name: "Nom",
    NameRequired: "Veuillez saisir le nom de la commune",
    deleteWarn: "Ceci supprimera la commune",
    suppressionEffectue: "Commune supprimée avec succès",
    NewMunicipalitie: "Nouvelle commune",
    iscreatedSuccessfully: "créee avec succès",
    isupdatedSuccessfully: "Mise à jour de la commune éffectuée avec succès !",
    created_at: "Créee le",
    edit: "Modifier la commune",
    AddMunicipalitie: "Nouvelle Commune",
    selectMunicipalityTitle: "Sélectionnez la commune",
    municipalityRequired: "Veuillez sélectionner une commune",
  },
  village: {
    village: "Village",
    villages: "Les villages",
    name: "Nom",
    NameRequired: "Veuillez saisir le nom du village",
    deleteWarn: "Ceci supprimera le village",
    suppressionEffectue: "Village supprimé avec succès",
    NewVillage: "Nouveau village",
    iscreatedSuccessfully: "crée avec succès",
    isupdatedSuccessfully: "Mise à jour du village éffectuée avec succès !",
    created_at: "Crée le",
    edit: "Modifier le village",
    AddVillage: "Nouveau Village",
    selectVillageTitle: "Sélectionnez le village",
    villageRequired: "Veuillez sélectionner une village",
  },
  registration: {
    registration: "Enregistrement",
    registrations: "Les enregistrements",
    ref: "Référence",
    maleNumber: "Mâles",
    femaleNumber: "Femelles",
    status: "État",
    coordinates: "Coordonnées",
    NameRequired: "Veuillez saisir le nom de la enregistrement",
    deleteWarn: "Ceci supprimera la enregistrement",
    suppressionEffectue: "Enregistrement supprimée avec succès",
    NewRegistration: "Nouvelle enregistrement",
    iscreatedSuccessfully: "crée avec succès",
    isupdatedSuccessfully: "Mise à jour de la enregistrement éffectuée avec succès !",
    created_at: "Créee le",
    edit: "Modifier la enregistrement",
    AddRegistration: "Nouvelle Enregistrement",
    selectRegistrationTitle: "Sélectionnez la enregistrement",
  },
  breed: {
    breed: "Race",
    breeds: "Les races",
    name: "Nom",
    description: "Description",
    NameRequired: "Veuillez saisir le nom de la race",
    deleteWarn: "Ceci supprimera la race",
    suppressionEffectue: "Race supprimée avec succès",
    NewBreed: "Nouvelle race",
    iscreatedSuccessfully: "crée avec succès",
    isupdatedSuccessfully: "Mise à jour de la race éffectuée avec succès !",
    created_at: "Créee le",
    edit: "Modifier la race",
    AddBreed: "Nouvelle Race",
    selectBreedTitle: "Sélectionnez la race",
  },
  disease: {
    disease: "Maladie",
    diseases: "Les maladies",
    name: "Nom",
    body: "Description",
    NameRequired: "Veuillez saisir le nom de la maladie",
    deleteWarn: "Ceci supprimera la maladie",
    suppressionEffectue: "Maladie supprimée avec succès",
    NewDisease: "Nouvelle Maladie",
    iscreatedSuccessfully: "créee avec succès",
    isupdatedSuccessfully: "Mise à jour de la maladie éffectuée avec succès !",
    created_at: "Créee le",
    edit: "Modifier la maladie",
    AddDisease: "Nouvelle Maladie",
    selectDiseaseTitle: "Sélectionnez la maladie",
    diseaseRequired: "Veuillez sélectionner une maladie",
    selectDiseasesTitle: "Sélectionnez les maladies",
    diseasesRequired: "Veuillez sélectionner les maladies",
  },
  subscription: {
    subscription: "Souscription",
    subscriptions: "Les Membres",
    organ: "Organe",
    story: "Histoire",
    age: "Age",
    height: "Taille",
    weight: "Poids",
    gender: "Genre",
    zip_code: "Code postal",
    type: "Type",
    travel: "Voyage",
    travel_no: "Ne peut pas voyage",
    travel_yes: "peut voyager",
    blod_type: "Groupe sanguin",
    OrganRequired: "Veuillez sélectionner un organ",
    BodyRequired: "Dites-nous plus sur vous !",
    deleteWarn: "Ceci supprimera la souscription",
    suppressionEffectue: "Souscription supprimée avec succès",
    NewSubscription: "Nouvelle Souscription",
    iscreatedSuccessfully: "créee avec succès",
    isupdatedSuccessfully:
      "Mise à jour de la souscription éffectuée avec succès !",
    created_at: "Créee le",
    edit: "Modifier la souscription",
    AddSubscription: "Nouvelle souscription",
    UserRequired: "Vous devez sélectionner un utilisateur",
    selectSubscriptionTitle: "Sélectionnez unde souscription",
    noSubscription: "Non souscrit",
    paired: "Paired",
  },
  report: {
    reported: "Reported",
    report: "Report",
    reports: "Les reports",
    subject: "Le sujet",
    reasons: "Description",
    SubjectRequired: "Veuillez saisir le subject de la report",
    BodyRequired: "Dites-nous en plus !",
    deleteWarn: "Ceci supprimera la report",
    suppressionEffectue: "Report supprimé avec succès",
    NewReport: "Nouvelle Report",
    iscreatedSuccessfully: "crée avec succès",
    isupdatedSuccessfully: "Mise à jour de l'report éffectuée avec succès !",
    created_at: "Crée le",
    edit: "Modifier l'report",
    AddReport: "Nouvelle report",
    UserRequired: "Vous devez sélectionner un utilisateur",
    selectReportTitle: "Sélectionnez l'report",
    processing: "Traitement",
    guest: "Invités",
  },
  discussion: {
    discussion: "Discussion",
    discussions: "Les discussions",
    sender: "Initiateur",
    with: "Avec",
  },
  article: {
    reported: "Reported",
    report: "Report",
    articles: "Les articles",
    title: "Titre",
    content: "COntenu",
    TitleRequired: "Veuillez saisir le titre de l'article",
    contentRequired: "Rédigez votre article !",
    deleteWarn: "Ceci supprimera l'article",
    suppressionEffectue: "Article supprimé avec succès",
    NewArticle: "Nouvel Article",
    iscreatedSuccessfully: "crée avec succès",
    isupdatedSuccessfully: "Mise à jour de l'article éffectuée avec succès !",
    created_at: "Crée le",
    edit: "Modifier l'article",
    addTitle: "Saisissez le titre de l'article",
    CategorieRequired: "Vous devez sélectionner une catégorie",
    selectCategorieTitle: "Sélectionnez la catégorie",
    addTitleandImageMessage:
      "Veuillez s'il vous plaît saisir le titre de l'article et ajouter l'mage par défaut",
    addSummary: "Ajouter le sommaire",
    addSummaryMessage:
      "Ajouter une petite description pouvant servir de sommaire pour votre article. Précisez l'importance qui servira à classer les articles",
    addCategory: "Sélectionnez une catégorie",
    addCategoryMessage:
      "Veillez sélectionner une catégorie, et gardez ouvert ou fermés les commentaires pour cet article",
    addTag: "Ajoutez des tags ! Quand voulez-vous publier ?",
    addTagMessage:
      "Ici vous pouvez préciser l'heure de la publication, vous pouvez égalment ajouter des tags. sélectionnez les tags à ajouter ou créez-en !",
    SummaryRequired: "Vous devez saisir un sommaire",
    CategoryRequired: "Vous devez sélectionner une catégorie",
    Addarticle: "Nouvelle article",
    approuvePost: "Approuver l'article",
    approuvePostMessage: "Êtes-vous sûr de vouloir publier cet article ?",
    yesPublish: "Oui publier",
    postDetails: "Détails de l'article",
  },
  comment: {
    comment: "Commentaire",
    comments: "Les commentaires",
    postTitle: "Article",
    deleteWarn: "Ceci supprimera l'article",
    suppressionEffectue: "Article supprimé avec succès",
    created_at: "Crée le",
    edit: "Modifier le commentaire",
  },
  localite: {
    localites: "Les localités",
    AddLocalite: "Nouvelle localité",
    nolocalite:
      "Pour commencer, cliquez sur le bouton (+) et ajoutez une localité ",
  },
  categorie: {
    categorie: "Categorie",
    categories: "Les categories",
    label: "Label",
    description: "Description",
    labelRequired: "Veuillez saisir le label de la catégorie",
    descriptionRequired: "Un petit détails s'il vous plaît !",
    deleteWarn: "Ceci supprimera la catégorie",
    suppressionEffectue: "catégorie supprimée avec succès",
    NewCategorie: "Nouvelle Catégorie",
    iscreatedSuccessfully: "créee avec succès",
    isupdatedSuccessfully:
      "Mise à jour de la catégorie éffectuée avec succès !",
    created_at: "Créee le",
    edit: "Modifier la catégorie",
    AddCategorie: "Nouvelle catégorie",
    CategorieRequired: "Vous devez sélectionner une catégorie",
    selectCategorieTitle: "Sélectionnez une catégorie",
    articleCount: "Articles",
  },
  tag: {
    tag: "Tag",
    tags: "Les tags",
    label: "Label",
    description: "Description",
    labelRequired: "Veuillez saisir le tag",
    deleteWarn: "Ceci supprimera le tag",
    suppressionEffectue: "Tag supprimé avec succès",
    NewTag: "Nouvel Tag",
    iscreatedSuccessfully: "crée avec succès",
    isupdatedSuccessfully: "Mise à jour du tag éffectuée avec succès !",
    created_at: "Crée le",
    edit: "Modifier le tag",
    AddTag: "Nouvel tag",
    selectTagTitle: "Ajoutez des tags",
  },
};
